// Third-party
import axios, { AxiosInstance } from 'axios';
import { ApiRequestConfig } from '@/utils/api';

const CSRF_TOKEN_HEADER_NAME = 'X-Connect-CSRF-Token';

export enum RequestType {
  Get = 'get',
  Put = 'put',
  Patch = 'patch',
  Post = 'post',
  Delete = 'delete',
}

export class Api {
  agent: AxiosInstance;

  constructor(baseURL: string | undefined) {
    this.agent = axios.create({
      baseURL,
      withCredentials: true,
    });
  }

  getResponse(res: { data: any }, config?: ApiRequestConfig) {
    if (config?.returnFullResponse) {
      return res;
    }
    return res.data;
  }

  get(url: string, config?: ApiRequestConfig) {
    return this.agent.get(url, config).then((res: { data: any }) => this.getResponse(res, config));
  }

  put(url: string, body?: any, config?: ApiRequestConfig) {
    return this.agent.put(url, body, config).then((res: { data: any }) => this.getResponse(res, config));
  }

  patch(url: string, body: any, config?: ApiRequestConfig) {
    return this.agent.patch(url, body, config).then((res: { data: any }) => this.getResponse(res, config));
  }

  post(url: string, body: any, config?: ApiRequestConfig) {
    return this.agent.post(url, body, config).then((res: { data: any }) => this.getResponse(res, config));
  }

  delete(url: string, config?: ApiRequestConfig) {
    return this.agent.delete(url, config).then((res: { data: any }) => this.getResponse(res, config));
  }

  setCSRFDefaultHeaders(csrfToken: string) {
    this.agent.defaults.headers.get[CSRF_TOKEN_HEADER_NAME] = csrfToken;
    this.agent.defaults.headers.post[CSRF_TOKEN_HEADER_NAME] = csrfToken;
    this.agent.defaults.headers.put[CSRF_TOKEN_HEADER_NAME] = csrfToken;
    this.agent.defaults.headers.patch[CSRF_TOKEN_HEADER_NAME] = csrfToken;
    this.agent.defaults.headers.delete[CSRF_TOKEN_HEADER_NAME] = csrfToken;
  }
}

export const API_URL = window.reactApiUrl === '{{REACT_API_URL}}' ? import.meta.env.REACT_APP_API_URL : window.reactApiUrl;

export const correlateApi = new Api(API_URL);
